module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "value": _vm.visible
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icon))]), _vm._v(" " + _vm._s(_vm.text))], 1), _vm._v(" "), _c('action-list', {
    attrs: {
      "appointment": _vm.appointment
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50290776","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/actions/ActionMenu.vue
// module id = 1423
// module chunks = 9